import React, { useMemo, useState } from 'react';
import { useRecipesQuery, useRecipeIngredientsQuery, useShoppingListQuery, useStockQuery, useProductsQuery, useQuantityUnitsQuery } from 'hooks/useQueries.ts';
import { useUnitConversion } from 'hooks/useUnitConversion.ts';
import RecipeList from './RecipeList.tsx';
import RecipeDetail from './RecipeDetail.tsx';
import { buildSortedRecipeState } from './recipeListState.ts';
import './RecipePage.css';
import RecipeSuggestions from './RecipeSuggestions.tsx';

const RecipePage: React.FC = () => {
  const [selectedRecipe, setSelectedRecipe] = useState<number | null>(null);
  
  const { data: recipes } = useRecipesQuery();
  const { data: recipeIngredients } = useRecipeIngredientsQuery();
  const { data: stock } = useStockQuery();
  const { data: products } = useProductsQuery();
  const { data: quantityUnits } = useQuantityUnitsQuery();
  const { data: shoppingListItems = [] } = useShoppingListQuery();
  const conversionService = useUnitConversion();
  const { sortedRecipes, recipeStockStatus } = useMemo(
    () => buildSortedRecipeState({
      recipes,
      recipeIngredients,
      stock,
      products,
      quantityUnits,
      shoppingListItems,
      conversionService,
    }),
    [conversionService, products, quantityUnits, recipeIngredients, recipes, shoppingListItems, stock]
  );

  return (
    <div className="recipe-page">
      <header className="recipe-page__header">
        <h1 className="recipe-page__title">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ verticalAlign: 'middle', marginRight: 8, color: 'var(--color-primary)' }}>
            <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
            <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
          </svg>
          Recipes
        </h1>
      </header>
      
      <main className="recipe-page__main">
        {selectedRecipe ? (
          <RecipeDetail
            recipe={recipes.find(r => r.id === selectedRecipe)!}
            recipeIngredients={recipeIngredients.filter(ri => ri.recipe_id === selectedRecipe)}
            products={products}
            quantityUnits={quantityUnits}
            recipeFulfillmentStatus={recipeStockStatus.get(selectedRecipe)}
            onBack={() => setSelectedRecipe(null)}
          />
        ) : (
          <>
            <RecipeSuggestions />
            <RecipeList
              recipes={sortedRecipes}
              recipeStockStatus={recipeStockStatus}
              onRecipeSelect={setSelectedRecipe}
            />
          </>
        )}
      </main>
    </div>
  );
};

export default RecipePage; 
